import { __decorate, __extends } from "tslib";
import { _SharePointQueryableInstance, _SharePointQueryableCollection, spInvokableFactory, } from "../sharepointqueryable.js";
import { defaultPath } from "../decorators.js";
import { tag } from "../telemetry.js";
/**
 * Describes a collection of Form objects
 *
 */
var _Forms = /** @class */ (function (_super) {
    __extends(_Forms, _super);
    function _Forms() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Gets a form by id
     *
     * @param id The guid id of the item to retrieve
     */
    _Forms.prototype.getById = function (id) {
        return tag.configure(Form(this).concat("('" + id + "')"), "fos.getById");
    };
    _Forms = __decorate([
        defaultPath("forms")
    ], _Forms);
    return _Forms;
}(_SharePointQueryableCollection));
export { _Forms };
export var Forms = spInvokableFactory(_Forms);
/**
 * Describes a single of Form instance
 *
 */
var _Form = /** @class */ (function (_super) {
    __extends(_Form, _super);
    function _Form() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return _Form;
}(_SharePointQueryableInstance));
export { _Form };
export var Form = spInvokableFactory(_Form);
